<template>
    <div id="historia-em-estampas">
        <div class="header-top pos-fixed d-flex flex-align-center">
            <div class="banner-left-top d-flex flex-align-center pos-fixed">
                <a href="/">
                    <div class="header-logo-cr logo-cr-circle" title="Chico Rei"></div>
                </a>
                <a href="/">
                    <div class="header-logo-cr logo-cr-text hidden-xs" title="Chico Rei"></div>
                </a>
            </div>
            <div class="banner-right-top d-flex flex-align-center pos-fixed">
                <OriginsMenu @scroll-to="scrollToAnchor($event)" :menu-links="menuLinks" />
            </div>
        </div>

        <div class="d-flex" style="z-index: 1; position: relative; background-color: white">
            <div v-for="images in imagesCabecalho">
                <img :src="images.link" :alt="images.alt" class="img-responsive" />
            </div>
        </div>

        <div
            class="anos-em-camisetas"
            v-prlx="{
                speed: 0.7,
                fromBottom: true,
                reverse: true,
                limit: { min: -300, max: 0 },
            }"
            style="z-index: 5; background-color: #ffffff; position: relative"
        >
            <div class="d-flex flex-column flex-justify-center flex-align-center content">
                <p class="text-uppercase">Uma História Chico Rei</p>
                <h3 class="text-uppercase">15 Anos em Camisetas</h3>
                <p>Existem muitas maneiras de se contar uma história.</p>

                <p>Para uma história que dura 15 anos, então… As possibilidades são infinitas.</p>
                <p>
                    A Chico Rei completa uma década e meia expressando criatividade através da moda.
                </p>
                <p>
                    Para te contar como chegamos até aqui, vamos substituir o
                    <strong>Era uma vez por Era uma camiseta…</strong>
                </p>
            </div>
        </div>

        <div id="first-section">
            <span class="content era-uma-vez-block"><strong>Era uma camiseta...</strong></span>
            <div
                class="header-block d-flex flex-justify-center flex-align-center"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 800 },
                }"
            >
                <h1>2008</h1>
            </div>
            <div class="d-flex hidden-xs-up">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/foto-bruno-2010-congado.png?auto=compress,format&q=65`"
                    alt="Bruno com Estampa Congado"
                    class="congado-02 img-responsive center-block"
                />
            </div>
            <div class="first-block">
                <div class="content d-flex flex-justify-between">
                    <div class="congado">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/congado-01.png?auto=compress,format&q=65`"
                            alt="Desfile Estampa Congado"
                            class="hidden-xs"
                        />
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/congado-desfile-mobile.png?auto=compress,format&q=65`"
                            alt="Desfile Estampa Congado"
                            class="hidden-xs-up img-responsive center-block"
                        />
                        <h2>Congado</h2>
                        <p>
                            A primeira de uma contagem que já ultrapassa a casa das seis mil. A
                            Congado foi a primeira estampa criada por nós. Sem saber o que viria
                            pela frente, misturamos duas das maiores referências da época: pop arte
                            e mineiridade. Esta última não ficou para trás e representa um tanto do
                            que você vai ver por aqui hoje.
                        </p>
                    </div>
                    <div class="d-flex flex-align-center hidden-xs">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/congado-02.png?auto=compress,format&q=65`"
                            alt="Estampa Congado"
                            class="congado-01"
                            v-prlx="{
                                custom: true,
                                limit: { min: 0, max: 50 },
                            }"
                        />
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/congado-03.png?auto=compress,format&q=65`"
                            alt="Bruno com Estampa Congado"
                            class="congado-02"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div id="second-section">
            <div
                class="header-block hidden-xs"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 800 },
                }"
            >
                <div class="overlay"><h1>2010</h1></div>
                <div>
                    <hr v-for="x in 15" />
                </div>
            </div>
            <div class="two-thousand-ten hidden-xs-up">
                <div class="overlay center-block"><h1>2010</h1></div>
            </div>
            <div class="first-block">
                <div class="d-flex flex-column flex-justify-center flex-align-center">
                    <div
                        class="matte-leaozis d-flex flex-column flex-align-center flex-justify-center"
                    >
                        <p style="font-size: 50px" clas="emoticons">🤫🤫🤫🤫🤫🤫</p>
                        <p class="text-bold">Matte Leãozis e Bec</p>

                        <p>
                            Só quem viveu sabe o porquê de não mostrarmos fotos dessas. Vamos só
                            dizer que as marcas não ficaram muito felizes com as homenagens. Você
                            vai entender que, em quinze anos, as notificações extrajudiciais acabam
                            chegando, vez ou outra… Mas vamos por partes!
                        </p>
                    </div>
                    <div class="content d-flex flex-justify-between hidden-xs">
                        <div class="brasilidade">
                            <h2>Brasilidade</h2>
                            <p>
                                Muito antes das estampas que representam o Brasil mais do que samba
                                e futebol, nos rendemos a uma das maiores tradições do nosso país.
                                Em uma homenagem à seleção brasileira, lançamos a Brasilidade na
                                Copa de 2010. O sucesso foi tamanho que, quatro anos depois, junto
                                com o evento, ela tava de volta! O mais bacana de tudo é que o(a)
                                cliente podia personalizar a camiseta, colocando seu nome nas
                                costas. Isso é único por aqui até hoje!
                            </p>
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/brasilidade-01.png?auto=compress,format&q=65`"
                                alt="Foto Copa Brasilidade"
                            />
                        </div>
                        <div>
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/brasilidade-02.png?auto=compress,format&q=65`"
                                alt="Brasilidade"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="hidden-xs-up">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/brasilidade-foto-copa.png?auto=compress,format&q=65`"
                    alt="Foto Copa Brasilidade"
                    class="img-responsive"
                />
                <div class="content">
                    <h2>Brasilidade</h2>
                    <p>
                        Muito antes das estampas que representam o Brasil mais do que samba e
                        futebol, nos rendemos a uma das maiores tradições do nosso país. Em uma
                        homenagem à seleção brasileira, lançamos a Brasilidade na Copa de 2010. O
                        sucesso foi tamanho que, quatro anos depois, junto com o evento, ela tava de
                        volta! O mais bacana de tudo é que o(a) cliente podia personalizar a
                        camiseta, colocando seu nome nas costas. Isso é único por aqui até hoje!
                    </p>
                </div>
            </div>
        </div>

        <section id="third-section">
            <div
                class="d-flex flex-justify-center flex-align-center header-block"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 500 },
                }"
            >
                <h1>2011</h1>
            </div>
            <div class="hidden-xs-up">
                <picture>
                    <source
                        :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/deselegante-mobile.png?auto=compress,format&q=65`"
                        media="(max-width: 576px)"
                    />
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/deselegante-02.png?auto=compress,format&q=65`"
                        alt="Estampa Que Deselegante"
                        class="img-responsive mb-3"
                    />
                </picture>
            </div>
            <div class="first-block">
                <div class="content d-flex">
                    <div class="que-deselegante">
                        <div class="content deselegante-block">
                            <div class="gif-deselegante">
                                <img
                                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/deselegante-01.gif?auto=compress,format&q=65`"
                                    alt="Gif Que Deselegante"
                                    width="373px"
                                    height="256px"
                                    class="img-responsive hidden-xs"
                                />
                                <img
                                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/gif-sandra-498.gif?auto=compress,format&q=65`"
                                    alt="Gif Que Deselegante"
                                    class="img-responsive hidden-xs-up gif-sandra"
                                />
                            </div>
                            <h2>Que Deselegante</h2>
                            <p>
                                Era 2011 quando Sandra Annenberg nos agraciou com um dos maiores
                                memes da história da internet. Num momento em que a frase “Que
                                deselegante!” não saía das nossas bocas e mentes, pensamos: “Por que
                                não carregá-la de vez no peito?”. Até a própria jornalista recebeu
                                uma camiseta, aprovou e usou!
                            </p>
                        </div>
                    </div>
                    <div class="hidden-xs">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/deselegante-02.png?auto=compress,format&q=65`"
                            alt="Estampa Que Deselegante"
                            class="mt-3"
                        />
                    </div>
                </div>
            </div>
            <div class="content kibe-loco">
                <div class="d-flex estampas-kibe">
                    <div class="kibe-loco-esquerda">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-kibe-loco-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/kibe-loco-01.png?auto=compress,format&q=65`"
                                alt="Estampa Kibe Loco"
                                class="img-responsive mr-3"
                            />
                        </picture>
                        <picture class="hidden-xs-up">
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-barbie-kill-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-barbie-kill.png?auto=compress,format&q=65`"
                                alt="Estampa Kibe Loco Barbie Kill"
                                class="img-responsive"
                            />
                        </picture>
                        <h2>Kibe Loco</h2>
                        <p>
                            Um baita ano, 2011! Em doze meses muita coisa louca aconteceu. Louca e
                            loca! O primeiro parceiro a assinar uma coleção por aqui foi o antigo
                            blog Kibe Loco. Eles abriram as portas para que centenas de outros
                            parceiros viessem depois!
                        </p>
                    </div>
                    <div class="hidden-xs">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-barbie-kill-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-barbie-kill.png?auto=compress,format&q=65`"
                                alt="Estampa Kibe Loco Barbie Kill"
                                class="img-responsive"
                            />
                        </picture>
                    </div>
                </div>
            </div>

            <div class="d-flex content final-third">
                <div class="jhonny-cash">
                    <picture>
                        <source
                            :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/johny-cash-mobile.png?auto=compress,format&q=65`"
                            media="(max-width: 576px)"
                        />
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/jhonny-cash.png?auto=compress,format&q=65`"
                            alt="Estampa Jhonny Cash"
                            class="img-responsive"
                        />
                    </picture>
                    <h2>Jhonny Cash</h2>
                    <p>Use a frase que quiser:</p>
                    <ul>
                        <li>“A experiência é o nome que damos aos nossos erros”</li>
                        <li>“Não corrigir nossas falhas é o mesmo que cometer novos erros”</li>
                        <li>“É errando que se aprende”...</li>
                    </ul>
                    <p>
                        Tudo deixa o mesmo legado e inicia a mesma história: a estampa Johnny Cash
                        gerou o nosso primeiro grande erro. Perdemos uma produção inteira quando
                        trocamos always por aways. O prejuízo foi grande, viu? Mas tudo bem, assim
                        entendemos que erarr é humano…
                    </p>
                </div>
            </div>
        </section>

        <div id="fourth-section">
            <div class="header-block">
                <div
                    class="d-flex flex-justify-center fourth-position"
                    v-prlx="{
                        speed: 0.6,
                        preserveInitialPosition: false,
                        limit: { min: 0, max: 600 },
                    }"
                >
                    <h1>2012</h1>
                </div>
                <div style="position: relative; z-index: 5">
                    <div class="d-flex flex-justify-around flex-align-center content raiz-block">
                        <div class="hidden-xs-up">
                            <picture>
                                <source
                                    :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/raiz-mobile.png?auto=compress,format&q=65`"
                                    media="(max-width: 576px)"
                                />
                                <img
                                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-raiz-de-minas.png?auto=compress,format&q=65`"
                                    alt="Estampa Raiz de Minas"
                                    class="hidden-xs-up img-responsive"
                                />
                            </picture>
                        </div>
                        <div class="raiz-de-minas">
                            <h2>Raiz de Minas</h2>
                            <p>
                                A mineiridade que a gente bate no peito pra falar - e vestir! São
                                mais de quarenta camisetas com a temática em nosso site. Cada uma do
                                seu jeitim, mineirim e conquistador! A Raiz de Minas representa bem
                                como a gente aprendeu a emplacar nosso DNA nos temas mais
                                tradicionais. De Minas pro mundo e de 2012 pro futuro!
                            </p>
                        </div>
                        <div>
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/estampa-raiz-de-minas.png?auto=compress,format&q=65`"
                                alt="Estampa Raiz de Minas"
                                class="hidden-xs"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="first-block coruja-second-block">
                <div class="content d-flex flex-justify-between coruja-block">
                    <div class="coruja-first">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/coruja-01.png?auto=compress,format&q=65`"
                            alt="Estampa Eu Sou Coruja"
                        />
                        <h2>Eu Sou Coruja</h2>
                        <p>
                            Representante da nossa primeira ação visando impacto social positivo, a
                            estampa Eu Sou Coruja foi uma das muitas desenvolvidas em parceria com a
                            antiga APAE de São Paulo, atual Instituto Jô Clemente. A corujinha
                            estampou algumas peças da coleção, que carregou o conceito “Quem é
                            coruja pega no pé e veste camiseta!”. Para a divulgação, contamos com
                            artistas como Murilo Rosa, Rodrigo Simas, Lua Blanco, Cauã Reymond e
                            outros.
                        </p>
                    </div>
                    <div class="hidden-xs-up">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/coruja-famosos-mobile.png?auto=compress,format&q=65`"
                            alt="Murilo Eu Sou Coruja"
                            class="img-responsive"
                        />
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/simas-mobile.png?auto=compress,format&q=65`"
                            alt="Rodrigo Simas Eu Sou Coruja"
                            class="img-responsive center-block mt-3"
                        />
                    </div>
                    <div class="d-flex flex-align-center hidden-xs">
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/coruja-02.png?auto=compress,format&q=65`"
                            alt="Murilo Eu Sou Coruja"
                            class="img-coruja-01 lazy lazy-fade"
                        />
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/coruja-03.png?auto=compress,format&q=65`"
                            alt="Simas Eu Sou Coruja"
                            class="img-coruja-02 lazy lazy-fade"
                        />
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/coruja-04.png?auto=compress,format&q=65`"
                            alt="Simas Eu Sou Coruja"
                            class="img-coruja-03 lazy lazy-fade"
                        />
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/coruja-05.png?auto=compress,format&q=65`"
                            alt="Lua Eu Sou Coruja"
                            class="img-coruja-04 lazy lazy-fade"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div id="fifth-section">
            <div class="d-flex flex-justify-between header-block">
                <div class="yellow-block hidden-xs"></div>
                <div
                    class="title-2013"
                    v-prlx="{
                        speed: 0.4,
                        preserveInitialPosition: false,
                        limit: { min: 0, max: 400 },
                    }"
                >
                    <h1>2013</h1>
                </div>
                <div class="gray-block hidden-xs"></div>
            </div>

            <div class="hidden-xs-up relax">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/relax-mobile-2.png?auto=compress,format&q=65`"
                    alt="O primeiro processo a gente nunca esquece"
                    class="img-responsive"
                />
                <div class="content">
                    <h2>Relax</h2>
                    <p>O primeiro processo a gente nunca esquece! Faz parte e ficou na memória…</p>
                </div>
            </div>
            <div class="hidden-xs-up ziraldo">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/ziraldo-mobile.png?auto=compress,format&q=65`"
                    alt="O primeiro processo a gente nunca esquece"
                    class="img-responsive"
                />
                <div class="content">
                    <h2>Menino Maluquinho</h2>
                    <p>
                        A tal da brasilidade é uma nota presente e frequente em nossas criações. E
                        ela se manifesta, ao longo destes anos, de diferentes maneiras. Ainda em
                        2013, tivemos a honra de lançar uma coleção em parceria com Ziraldo, a
                        primeira com um artista brasileiro. Ela não tá mais disponível em nosso
                        site, mas foi bom (demais!) enquanto durou.
                    </p>
                </div>
            </div>

            <div
                class="d-flex flex-justify-center first-block hidden-xs"
                style="position: relative; z-index: 5"
            >
                <div class="content relax d-flex flex-align-center flex-justify-center">
                    <div>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/processo-01.png?auto=compress,format&q=65`"
                            alt="O primeiro processo a gente nunca esquece"
                        />
                        <h2>Relax</h2>
                        <p>
                            O primeiro processo a gente nunca esquece! Faz parte e ficou na memória…
                        </p>
                    </div>
                </div>
                <div class="gray d-flex flex-justify-center flex-align-center">
                    <div>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/menino-maluquinho.png?auto=compress,format&q=65`"
                            alt="Estampa Menino Maluquinho"
                        />
                        <h2>Menino Maluquinho</h2>
                        <p>
                            A tal da brasilidade é uma nota presente e frequente em nossas criações.
                            E ela se manifesta, ao longo destes anos, de diferentes maneiras. Ainda
                            em 2013, tivemos a honra de lançar uma coleção em parceria com Ziraldo,
                            a primeira com um artista brasileiro. Ela não tá mais disponível em
                            nosso site, mas foi bom (demais!) enquanto durou.
                        </p>
                    </div>
                </div>
            </div>
            <div class="hidden-xs-up rock-will-never-die-block">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/rock-will-never-die-mobile.png?auto=compress,format&q=65`"
                    alt="Estampa Rock Will Never Die"
                    class="img-responsive"
                />
                <div class="rock-will-never-die">
                    <div class="content">
                        <h2>Rock Will Never Die</h2>
                        <p>
                            Entre altos e baixos, 2013 teve seu valor! Depois de um marco negativo
                            veio um super positivo! Lançamos a coleção Rock in Rio, nosso primeiro
                            grande licenciamento. Dez anos depois, seguimos afirmando: o rock não
                            morreu! E nem a coleção! Se você também é rock até os ossos, ainda pode
                            vestir a homenagem.
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-justify-around flex-align-end second-block hidden-xs">
                <div class="rock-will-never-die">
                    <h2>Rock Will Never Die</h2>
                    <p>
                        Entre altos e baixos, 2013 teve seu valor! Depois de um marco negativo, veio
                        um super positivo! Lançamos a coleção Rock in Rio, nosso primeiro grande
                        licenciamento. Dez anos depois, seguimos afirmando: o rock não morreu! E nem
                        a coleção! Se você também é rock até os ossos, ainda pode vestir a
                        homenagem.
                    </p>
                </div>
                <div>
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/rock-will-never-die.png?auto=compress,format&q=65`"
                        alt="Estampa Rock Will Never Die"
                    />
                </div>
            </div>
        </div>

        <div id="sixth-section">
            <div
                class="d-flex flex-justify-center header-block"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 250 },
                }"
            >
                <div>
                    <h1>2014</h1>
                </div>
            </div>
            <div class="d-flex copadecida-block">
                <div class="first-block">
                    <div class="content copadecida">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/o-auto-da-compadecida-01.png?auto=compress,format&q=65`"
                            alt="Estampa o Auto da Compadecida"
                            class="hidden-xs"
                        />
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/compadecida-mobile.png?auto=compress,format&q=65`"
                            alt="Estampa o Auto da Compadecida"
                            class="hidden-xs-up img-responsive"
                        />
                        <div class="o-auto-da-compadecida">
                            <h2>O Auto da Compadecida</h2>
                            <p>
                                Cê com certeza já cruzou com essa estampa por aí! Em nossos canais
                                ou aplicadas a produtos nada oficiais… Foi lançada em 2014 e tá na
                                história como um dos nossos maiores sucessos - e a mais plagiada
                                também! Uma mistura de humor, brasilidade, cultura pop e
                                xilogravura. Se fosse pra resumir a Chico Rei em poucas palavras,
                                essas com certeza seriam lembradas.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="second-block">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/o-auto-da-compadecida-02.png?auto=compress,format&q=65`"
                        alt="Estampa o Auto da Compadecida"
                        class="hidden-xs"
                    />

                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/compdadecida-modelo-mobile.png?auto=compress,format&q=65`"
                        alt="Estampa o Auto da Compadecida"
                        class="hidden-xs-up img-responsive"
                    />
                </div>
            </div>
        </div>

        <div id="seventh-section">
            <div class="d-flex flex-justify-center flex-align-center black-background">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/mistico-img-01.png?auto=compress,format&q=65`"
                    alt="Mistico"
                    class="mistico-01 img-responsive"
                />
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/mistico-img-02.png?auto=compress,format&q=65`"
                    alt="Mistico"
                    class="mistico-02 img-responsive"
                />
                <h1
                    v-prlx="{
                        speed: 0.5,
                        preserveInitialPosition: false,
                        limit: { min: -100, max: 240 },
                    }"
                >
                    2015
                </h1>
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/mistico-img-03.png?auto=compress,format&q=65`"
                    alt="Mistico"
                    class="mistico-03 img-responsive"
                />
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/mistico-img-04.png?auto=compress,format&q=65`"
                    alt="Mistico"
                    class="mistico-04 img-responsive"
                />
            </div>
            <div class="mistico-background">
                <div class="content mistico-padding">
                    <div class="mistico">
                        <h2>Místico</h2>
                        <p>
                            Nossas camisas de botão só chegaram em 2021. Mas muito se engana quem
                            pensa que elas foram nossa primeira experimentação em full print. A
                            famosa Místico foi lançada em 2015, iniciando uma nova onda de sucessos
                            na Chico, a fase das estampas corridas. Os desenhos tomavam conta de
                            toda a camiseta. Hoje usamos esse tipo de aplicação em outros produtos,
                            como os shorts e as camisas.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div id="eighth-session">
            <div
                class="d-flex flex-justify-center flex-align-center"
                style="height: 65vh; position: relative; z-index: 1"
                v-prlx="{
                    speed: 0.5,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 200 },
                }"
            >
                <h1>2016</h1>
            </div>
            <div class="content d-flex flex-justify-between geraes-block">
                <div class="geraes">
                    <div class="geraes-mobile hidden-xs-up">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/trem.gif?auto=compress,format&q=65`"
                            alt="Estampa Geraes"
                            class="img-responsive"
                        />

                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/camiseta-geraes-mobile.png?auto=compress,format&q=65`"
                            alt="Estampa Geraes"
                            class="img-responsive"
                        />
                    </div>

                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/geraes-01.png?auto=compress,format&q=65`"
                        alt="Estampa Geraes"
                        class="img-responsive"
                    />

                    <h2>Geraes</h2>
                    <p>
                        Como pode um desenho tão simples mexer com todos os nossos sentidos? Não se
                        engane pela simplicidade - e nem se apresse em julgá-la. Em 2016, estampamos
                        a capa do álbum Geraes, de 1976, de uma das maiores lendas da música
                        brasileira. A estampa é o maior sucesso da nossa coleção oficial com Milton
                        Nascimento - coleção essa que iniciou uma leva de parcerias com artistas da
                        música nacional. Te conto mais logo adiante…
                    </p>
                </div>
                <div
                    class="d-flex flex-align-center hidden-xs"
                    style="margin-top: 8rem; position: relative; z-index: 5"
                >
                    <div>
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/geraes-02.png?auto=compress,format&q=65`"
                            alt="Estampa Geraes"
                            class="geraes-01 lazy lazy-fade"
                        />
                    </div>
                    <div>
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/trem.gif?auto=compress,format&q=65`"
                            alt="Estampa Geraes"
                            class="geraes-02 lazy lazy-fade"
                            width="303px"
                            height="144px"
                        />
                    </div>
                    <div>
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/geraes-04.png?auto=compress,format&q=65`"
                            alt="Estampa Geraes"
                            class="geraes-03 lazy lazy-fade"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div id="ninth-session">
            <div class="first-block">
                <div
                    class="d-flex flex-justify-center flex-align-center header-block"
                    v-prlx="{
                        speed: 0.5,
                        preserveInitialPosition: false,
                        limit: { min: 0, max: 200 },
                    }"
                >
                    <h1>2017</h1>
                </div>
                <div class="d-flex flex-justify-around flex-align-end">
                    <div class="hidden-xs-up">
                        <img
                            :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/camiseta-preto-noir.png?auto=compress,format&q=65`"
                            alt="Camiseta Básica Preto Noir"
                            class="img-responsive lazy lazy-fade"
                        />
                    </div>
                    <div class="preto-noir">
                        <h2>Básica Preto Noir</h2>
                        <p>
                            Em 2017, já grandes aprendizes de que nem tudo são flores, descobrimos
                            também que nem tudo são estampas. Demos ouvido a uma grande necessidade
                            do nosso cliente e lançamos a Linha Básica. Entendemos de vez que o
                            significado de ser básico não é sinônimo de sem graça.
                        </p>
                    </div>
                    <div class="hidden-xs">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/camiseta-preto-noir.png?auto=compress,format&q=65`"
                            alt="Camiseta Básica Preto Noir"
                            class="lazy-fade"
                        />
                    </div>
                </div>
            </div>
            <div class="second-block">
                <div class="content d-flex flex-justify-center flex-align-center errar-block">
                    <div class="erarr-e-humano">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/erarr-e-humano-01.png?auto=compress,format&q=65`"
                            alt="Erarr é humano"
                            class="img-responsive"
                        />
                        <h2>Erarr</h2>
                        <p>
                            Essa é uma boa representante de uma parte da nossa história que dá um
                            orgulho danado: a Galeria de Artistas, um projeto que teve início em
                            2017. Através dela, apresentamos peças com criativos de pessoas que
                            admiramos e que são a cara da Chico Rei. Com uma curadoria,
                            possibilitamos que artistas ofereçam produtos diferenciados e tenham
                            ganhos financeiros reais. Essa estampa é da coleção do Jackson Duarte,
                            um dos mais de vinte nomes que compõem o espaço.
                        </p>
                    </div>
                    <div>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/erarr-e-humano-02.png?auto=compress,format&q=65`"
                            alt="Estampa Erarr é humano"
                            class="img-responsive"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div id="tenth-session">
            <div
                class="d-flex flex-justify-center flex-align-center header-block"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 500 },
                }"
            >
                <h1>2018</h1>
            </div>
            <div class="first-block">
                <div
                    class="content d-flex"
                    :class="[isMobile ? 'flex-column' : 'flex-justify-between']"
                >
                    <div class="nos-podemos">
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/nos-podemos-01.png?auto=compress,format&q=65`"
                            alt="Estampa Nós Podemos Mônica"
                            class="img-responsive"
                        />
                        <h2>Nós Podemos</h2>
                        <p>
                            Sim, nós podemos - e fizemos! A coleção oficial com a Turma da Mônica
                            chegou em 2018 e marcou nossa história. Hoje já não está mais
                            disponível, mas vale a lembrança!
                        </p>
                    </div>
                    <div>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/nos-podemos-02.png?auto=compress,format&q=65`"
                            alt="Estampa Nós Podemos Mônica"
                            class="img-nos-podemos img-responsive"
                        />
                    </div>
                </div>
            </div>
            <div class="content d-flex second-block">
                <div class="content">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/frida-kahlo-01.png?auto=compress,format&q=65`"
                        alt="Estampa No Te Demores"
                    />
                    <h2>No Te Demores</h2>
                    <p>
                        “Onde não puderes amar, não te demores”. Foi com Frida Kahlo que
                        compreendemos a razão de estarmos construindo uma história tão longa
                        enquanto marca. Na Chico Rei tem muito amor. E, desde 2018, tem Frida
                        também! Temos orgulho de dizer que fomos a primeira marca de camisetas da
                        América Latina a lançar uma coleção oficial com a artista. Uma baita
                        responsabilidade! Hoje já são mais de trinta estampas.
                    </p>
                </div>
                <div class="hidden-xs-up mt-5">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/fotos-frida-mobile.png?auto=compress,format&q=65`"
                        alt="Estampa Frida Kahlo"
                        class="img-responsive"
                    />
                </div>
                <div class="d-flex flex-align-center hidden-xs">
                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/frida-kahlo-02.png?auto=compress,format&q=65`"
                        alt="Estampa Frida Kahlo"
                        class="frida-01 lazy lazy-fade"
                    />
                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/frida-kahlo-03.png?auto=compress,format&q=65`"
                        alt="Estampa Frida Kahlo"
                        class="frida-02 lazy lazy-fade"
                    />
                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/frida-kahlo-04.png?auto=compress,format&q=65`"
                        alt="Estampa Frida Kahlo"
                        class="frida-03 lazy lazy-fade"
                    />
                    <img
                        :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/frida-kahlo-05.png?auto=compress,format&q=65`"
                        alt="Estampa Frida Kahlo"
                        class="frida-04 lazy lazy-fade"
                    />
                </div>
            </div>
        </div>

        <div id="eleventh-session">
            <div class="d-flex flex-justify-center flex-align-center header-block">
                <h1
                    v-prlx="{
                        speed: 0.4,
                        preserveInitialPosition: false,
                        limit: { min: 0, max: 150 },
                    }"
                >
                    2019
                </h1>
            </div>
            <div class="hidden-xs-up">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/black-heart-mobile.png?auto=compress,format&q=65`"
                    alt="Estampa Frida Kahlo"
                    class="img-responsive"
                />
            </div>
            <div class="d-flex flex-justify-around first-block">
                <div class="d-flex flex-column flex-align-center black-heart-block">
                    <img
                        v-prlx="{
                            speed: 0.6,
                            direction: 'x',
                            limit: { min: 0, max: 200 },
                        }"
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/black-heart-01.png?auto=compress,format&q=65`"
                        alt="Estampa Black Heart"
                        class="hidden-xs img-black-heart"
                    />
                    <div class="black-heart">
                        <h2>Black Heart</h2>
                        <p>
                            Falando em amor… A camiseta Black Heart provou que menos é (muito) mais!
                            Ela deu início às nossas “estampas no peito” - e segue sendo um baita
                            sucesso.
                        </p>
                    </div>
                </div>
                <div class="d-flex flex-align-center hidden-xs">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/black-heart-02.png?auto=compress,format&q=65`"
                        alt="Estampa Black Heart"
                        class="black-heart-01"
                    />
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/black-heart-03.png?auto=compress,format&q=65`"
                        alt="Estampa Black Heart"
                        class="black-heart-02"
                    />
                </div>
                <div class="hidden-xs-up">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/black-heart-01-mobile.png?auto=compress,format&q=65`"
                        alt="Estampa Black Heart"
                        class="img-responsive mt-5"
                    />
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/black-heart-02-mobile.png?auto=compress,format&q=65`"
                        alt="Estampa Black Heart"
                        class="img-responsive mt-5"
                    />
                </div>
            </div>
        </div>

        <div id="twelfth-session">
            <div
                class="d-flex flex-column flex-justify-center flex-align-center header-block"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 500 },
                }"
            >
                <img
                    :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/2020-img.png?auto=compress,format&q=65`"
                    alt="Imagem 2020"
                    class="img-responsive bandeira"
                />
                <h1>2020</h1>
            </div>
            <div class="first-block">
                <div
                    class="content d-flex"
                    :class="[isMobile ? 'flex-column' : 'flex-justify-center']"
                >
                    <div
                        class="ame-tudo-que-puder"
                        v-prlx="{
                            speed: 0.4,
                            preserveInitialPosition: false,
                            limit: { min: 0, max: 330 },
                        }"
                    >
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/ame-tudo-que-puder-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/tiago-iorc.png?auto=compress,format&q=65`"
                                alt="Estampa Tiago Iorc"
                                class="img-responsive"
                            />
                        </picture>
                        <h2>Ame Tudo Que Puder</h2>
                        <p>
                            Em meio a um período incerto e aterrorizante, em que começávamos a
                            vivenciar a pandemia, um susto veio para o bem. Ame Tudo Que Puder, da
                            coleção com Tiago Iorc, foi lançada em maio de 2020 e entrou pra
                            história como nosso maior sucesso de vendas em um único dia. Toda a
                            renda foi revertida para a confecção e doação de máscaras no combate à
                            COVID-19.
                        </p>
                    </div>
                    <div class="paciencia">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/lenine-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/lenine.png?auto=compress,format&q=65`"
                                alt="Estampa Paciência"
                                class="img-responsive"
                            />
                        </picture>
                        <h2>Paciência</h2>
                        <p>
                            Ainda em meio a um dos grandes momentos de tensão que já vivemos
                            enquanto marca e sociedade, a camiseta Paciência veio como um afago.
                            Mais um lançamento que permitiu que ajudássemos nossa comunidade. Foi
                            lançada em parceria com Lenine e teve sua renda revertida para a cadeia
                            de produção musical que foi prejudicada pela pandemia de coronavírus, do
                            motorista até a banda.
                        </p>
                    </div>
                </div>
            </div>
            <div class="second-block">
                <div class="content d-flex flex-align-center alceu-block">
                    <div class="alceu">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-dispor-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-01.png?auto=compress,format&q=65`"
                                alt="Estampa Alceu Dispor"
                                class="img-responsive"
                            />
                        </picture>
                        <div class="alceu-dispor">
                            <h2>Alceu Dispor</h2>
                            <p>
                                Perdoe o trocadilho, mas que ele deu certo, deu demais! A Alceu
                                Dispor reflete como muitas artes surgem por aqui: a partir de ideias
                                despretensiosas e bons papos de corredor. Essa sacada saiu da
                                estampa pro título da turnê de Alceu Valença.
                            </p>
                        </div>
                    </div>
                    <div class="d-flex flex-align-center second-block">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-1-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-02.png?auto=compress,format&q=65`"
                                alt="Camiseta Tu Vens"
                                class="img-responsive alceu-01 lazy lazy-fade"
                            />
                        </picture>

                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-2-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-03.png?auto=compress,format&q=65`"
                                alt="Camiseta Alceu Dispor"
                                class="img-responsive alceu-02 lazy lazy-fade"
                            />
                        </picture>

                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-3-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/alceu-04.png?auto=compress,format&q=65`"
                                alt="Camiseta Um girassol nos teus cabelos"
                                class="img-responsive alceu-03 lazy lazy-fade"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>

        <div id="thirteenth-session">
            <div class="d-flex flex-justify-center flex-align-center header-block">
                <h1
                    v-prlx="{
                        speed: 0.4,
                        preserveInitialPosition: false,
                        limit: { min: 0, max: 200 },
                    }"
                >
                    2021
                </h1>
            </div>
            <div class="content d-flex pagodinho-block">
                <div class="first-block">
                    <picture>
                        <source
                            :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/pagodinho-mobile.png?auto=compress,format&q=65`"
                            media="(max-width: 576px)"
                        />
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/zeca-01.png?auto=compress,format&q=65`"
                            alt="Estampa Pagodinho"
                            class="img-responsive"
                        />
                    </picture>
                    <div class="zeca-pagodinho">
                        <h2>Pagodinho</h2>
                        <p>
                            Zeca Pagodinho nos ensinou que camarão que dorme a onda leva. Nós, que
                            não somos nem bobos nem nada, fomos logo atrás de lançar uma coleção com
                            o artista! A estampa mais famosa é a Pagodinho, que surgiu a partir de
                            um meme. A renda da coleção é revertida pro Instituto Zeca Pagodinho,
                            uma escola de capacitação artística e cultural em música sinfônica,
                            artes integradas e cidadania. Um trabalho bonito por demais, que ganhou
                            estampas à altura!
                        </p>
                    </div>
                </div>
                <div class="d-flex flex-align-center second-block">
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/zeca-02.png?auto=compress,format&q=65`"
                        alt="Camiseta Pagodinho"
                        class="zeca-pagodinho-01 img-responsive"
                    />
                    <img
                        :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/zeca-03.png?auto=compress,format&q=65`"
                        alt="Camiseta Pagodinho"
                        class="zeca-pagodinho-02 img-responsive"
                    />
                </div>
            </div>
        </div>

        <div id="fourteenth-session">
            <div
                class="d-flex flex-align-center flex-justify-between header-block"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 500 },
                }"
            >
                <div class="yellow-block hidden-xs"></div>
                <div class="title-block">
                    <h1>2022</h1>
                </div>
                <div class="green-block hidden-xs"></div>
            </div>
            <div class="first-block">
                <div class="yellow-right hidden-xs"></div>
                <div
                    class="d-flex"
                    :class="[
                        isMobile
                            ? 'flex-column flex-justify-center'
                            : 'content flex-justify-between',
                    ]"
                >
                    <div>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/clube-da-esquina-01.png?auto=compress,format&q=65`"
                            alt="Estampa Um girassol da cor de seu cabelo"
                            class="img-responsive"
                        />
                        <h2>Um Girassol da Cor do Seu Cabelo</h2>
                        <p>
                            Um dos maiores movimentos da música brasileira ganhou uma coleção pra
                            chamar de sua em 2022 por aqui! Lançamos estampa de O Clube da Esquina
                            com imagens exclusivas de Milton Nascimento.
                        </p>
                        <div class="yellow-left hidden-xs"></div>
                    </div>
                    <video
                        :width="[isMobile ? '100%' : '408px']"
                        height="680"
                        controls
                        autoplay
                        muted
                    >
                        <source
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/clube-da-esquina-video.mp4`"
                            type="video/mp4"
                        />
                        Seu navegador não suporta o vídeo
                    </video>
                </div>
                <div class="block-01 hidden-xs"></div>
            </div>
            <div class="block-02 hidden-xs"></div>
            <div class="block-03 hidden-xs"></div>
            <div class="block-04 hidden-xs"></div>
            <div class="second-block">
                <div
                    class="d-flex"
                    :class="[
                        isMobile
                            ? 'flex-column flex-justify-center'
                            : 'content flex-justify-between',
                    ]"
                >
                    <div>
                        <img
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/colecao-copa-01.png?auto=compress,format&q=65`"
                            alt="Estampa Rumo ao Hexa"
                            class="img-responsive"
                        />
                        <h2>Rumo ao Hexa</h2>
                        <p>
                            Do limão à limonada, que nada! A gente fez mesmo da divisão, a união!
                            Num momento tão dividido em nosso país, conseguimos trazer as cores de
                            nossa bandeira de volta ao uso de nossos clientes. A Rumo ao Hexa compôs
                            nossa Coleção Copa e foi um dos maiores sucessos de nossa história. Em
                            tempos de Copa do Mundo, é certamente o maior sucesso que já tivemos.
                        </p>
                        <div class="green-left"></div>
                    </div>
                    <video
                        :width="[isMobile ? '100%' : '408px']"
                        height="680"
                        controls
                        autoplay
                        muted
                    >
                        <source
                            :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/rumo-ao-hexa-video.mp4`"
                            type="video/mp4"
                        />
                        Seu navegador não suporta o vídeo
                    </video>
                </div>
            </div>
        </div>

        <div id="fifteenth-session">
            <div
                class="d-flex flex-justify-center flex-align-center header-block"
                v-prlx="{
                    speed: 0.4,
                    preserveInitialPosition: false,
                    limit: { min: 0, max: 600 },
                }"
            >
                <h1>2023</h1>
            </div>
            <div class="irmaos-do-jorel">
                <div
                    class="content d-flex"
                    :class="[isMobile ? 'flex-column flex-justify-center' : 'flex-justify-between']"
                >
                    <div class="first-block">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/vovo-juju-mobile.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmaos-jorel-01.png?auto=compress,format&q=65`"
                                alt="Estampa Vovó do Jorel"
                                class="img-responsive"
                            />
                        </picture>
                        <h2>Irmão do Jorel</h2>
                        <p>
                            Uma das estampas mais vendidas de uma das nossas maiores coleções - em
                            todos esses 15 anos! Irmão do Jorel é gigante e a coleção lançada este
                            ano só reforça ainda mais isso. Em menos de 1 ano e através de 8
                            estampas, provou que o tempo é totalmente relativo! Foi difícil escolher
                            uma representante, então te mostramos algumas!
                        </p>
                    </div>
                    <div class="d-flex flex-align-center jorel-block">
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmao-do-jorel-mobile-1.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmaos-jorel-02.png?auto=compress,format&q=65`"
                                alt="Camiseta Muito Doido"
                                class="irmaos-jorel-01 img-responsive lazy lazy-fade"
                            />
                        </picture>
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmao-do-jorel-mobile-2.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmaos-jorel-03.png?auto=compress,format&q=65`"
                                alt="Camiseta Cueca em Chamas"
                                class="irmaos-jorel-02 img-responsive lazy lazy-fade"
                            />
                        </picture>
                        <picture>
                            <source
                                :srcset="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmao-do-jorel-mobile-4.png?auto=compress,format&q=65`"
                                media="(max-width: 576px)"
                            />
                            <img
                                :data-src="`${$scope.CDN_IMAGES}/images/hotsites/historia-em-estampas/irmaos-jorel-04.png?auto=compress,format&q=65`"
                                alt="Camiseta Gesonel"
                                class="irmaos-jorel-03 img-responsive lazy lazy-fade"
                            />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OriginsMenu from '../origins/OriginsMenu.vue';
    import { resizeOrientationAware, updateLazyLoad } from '../../../../../submodules/src/script/common';

    export default {
        name: 'HistoryInPrints',

        components: {
            OriginsMenu,
        },

        el: '#historia-em-estampas',

        data() {
            return {
                resizeAwareRemoveCb: null,
                imagesCabecalho: [
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-01.png?auto=compress,format&q=65',
                        alt: 'Estampa Raiz de Minas',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-02.png?auto=compress,format&q=65',
                        alt: 'Estampa Geraes',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-03.png?auto=compress,format&q=65',
                        alt: 'Estampa Rock Will Never Die',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-4.png?auto=compress,format&q=65',
                        alt: 'Estampa Alceu Dispor',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-05.png?auto=compress,format&q=65',
                        alt: 'Estampa Congado',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-06.png?auto=compress,format&q=65',
                        alt: 'Estampa O Auto da Compadecida',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-07.png?auto=compress,format&q=65',
                        alt: 'Estampa No Te Demores',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-08.png?auto=compress,format&q=65',
                        alt: 'Estampa Rumo ao Hexa',
                    },
                    {
                        link:
                            this.$scope.CDN_IMAGES +
                            '/images/hotsites/historia-em-estampas/cabecalho-09.png?auto=compress,format&q=65',
                        alt: 'Estampa MC Juju',
                    },
                ],
                menuLinks: [
                    {
                        name: '2008',
                        anchor: 'first-section',
                    },
                    {
                        name: '2010',
                        anchor: 'second-section',
                    },
                    {
                        name: '2011',
                        anchor: 'third-section',
                    },
                    {
                        name: '2012',
                        anchor: 'fourth-section',
                    },
                    {
                        name: '2013',
                        anchor: 'fifth-section',
                    },
                    {
                        name: '2014',
                        anchor: 'sixth-section',
                    },
                    {
                        name: '2015',
                        anchor: 'seventh-section',
                    },
                    {
                        name: '2016',
                        anchor: 'eighth-session',
                    },
                    {
                        name: '2017',
                        anchor: 'ninth-session',
                    },
                    {
                        name: '2018',
                        anchor: 'tenth-session',
                    },
                    {
                        name: '2019',
                        anchor: 'eleventh-session',
                    },
                    {
                        name: '2020',
                        anchor: 'twelfth-session',
                    },
                    {
                        name: '2021',
                        anchor: 'thirteenth-session',
                    },
                    {
                        name: '2022',
                        anchor: 'fourteenth-session',
                    },
                    {
                        name: '2023',
                        anchor: 'fifteenth-session',
                    },
                ],
                isMobile: false,
            };
        },

        mounted() {
            updateLazyLoad();
            this.resizeAwareRemoveCb = resizeOrientationAware(() => this.onResize(), true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        methods: {
            scrollToAnchor(anchor) {
                cr$.byId(anchor).scrollIntoView();
                cr$.byClass('icon-close').click();
            },

            onResize() {
                this.isMobile = window.innerWidth < 768;
            },
        },
    };
</script>
